
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleChannelContainer from '~/components/child/article/ArticleChannelContainer.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleHotContainer from '~/components/child/article/ArticleHotContainer.vue';
export default {
    name: "travel",
    components: { BannerContainer, TagContainer, RecipeContainer, BrowseContainer, ArticleChannelContainer, BloggerRankingChannel, ArticleHotContainer },
    head() {
        return {
            title: '身心靈-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦匯聚星座、塔羅、紫微、命理、生肖等身心靈內容，是可以分享個人對於星座、紫微、算命、塔羅等議題的研究和心得。同時也能透過閱讀其他網友的文章，擴展您對於身心靈主題的理解和視野。無論您是專業研究者、或是初學者，痞客邦都是一個讓您發聲和學習的平台。加入我們，共同創造一個充滿智慧和靈感的網絡空間。' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦匯聚星座、塔羅、紫微、命理、生肖等身心靈內容，是可以分享個人對於星座、紫微、算命、塔羅等議題的研究和心得。同時也能透過閱讀其他網友的文章，擴展您對於身心靈主題的理解和視野。無論您是專業研究者、或是初學者，痞客邦都是一個讓您發聲和學習的平台。加入我們，共同創造一個充滿智慧和靈感的網絡空間。' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦匯聚星座、塔羅、紫微、命理、生肖等身心靈內容，是可以分享個人對於星座、紫微、算命、塔羅等議題的研究和心得。同時也能透過閱讀其他網友的文章，擴展您對於身心靈主題的理解和視野。無論您是專業研究者、或是初學者，痞客邦都是一個讓您發聲和學習的平台。加入我們，共同創造一個充滿智慧和靈感的網絡空間。' },
                { hid: 'keywords', name: 'keywords', content: '算命,星座命盤,星盤,算命,紫微,命盤,今日運勢,流年運勢,配對,桃花,運勢,姓名,流年,塔羅,事業運勢,占卜' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "身心靈-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_spirit_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_spirit_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_spirit_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_spirit_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/body-mind-spirit', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_spirit_og.png",
                    "name":"痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"痞客邦匯聚星座、塔羅、紫微、命理、生肖等身心靈內容，是可以分享個人對於星座、紫微、算命、塔羅等議題的研究和心得。同時也能透過閱讀其他網友的文章，擴展您對於身心靈主題的理解和視野。無論您是專業研究者、或是初學者，痞客邦都是一個讓您發聲和學習的平台。加入我們，共同創造一個充滿智慧和靈感的網絡空間。",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_spirit_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "身心靈-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦匯聚星座、塔羅、紫微、命理、生肖等身心靈內容，是可以分享個人對於星座、紫微、算命、塔羅等議題的研究和心得。同時也能透過閱讀其他網友的文章，擴展您對於身心靈主題的理解和視野。無論您是專業研究者、或是初學者，痞客邦都是一個讓您發聲和學習的平台。加入我們，共同創造一個充滿智慧和靈感的網絡空間。",
                            "keywords": "算命,星座命盤,星盤,算命,紫微,命盤,今日運勢,流年運勢,配對,桃花,運勢,姓名,流年,塔羅,事業運勢,占卜"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            channel_page_id: 9,
            showAnimation: false,
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        pa_page_name() {
            return '身心靈';
        },
        tag_search_text() {
            return '身心靈';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        }
    },
    methods: {
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '身心靈'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '身心靈'
            });
            this.gtag('event', 'page_view', {
                page_title: '身心靈-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
    },
    async fetch(){
        const item = { sort: 'hot', type: 'group', pre_page: 10, id: 9, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);
    },
    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.activeGaPage();
        this.activeMcPage();
        this.paFunction();
        this.paScrollFunction();
    }
}
